/**
 * @module api-web:assemblyAndDisassemblyRelation.jc
 */

import service from '@/service'

/**
 * @param {{
 * productCode:string,
 * supplier:string}} params
 * @description  查询列表
 */
export function getList(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/getList',
    method: 'post',
    data
  })
}

/**
 * 创建
 * @param {object} data
 * @returns {object}
 */
export function create(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/save',
    method: 'post',
    data
  })
}

/**
 * 更新
 * @param {object} data
 * @returns {object}
 */
export function update(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/update',
    method: 'post',
    data
  })
}
/**
 *  提交
 * @param {Array<string|number>} ids
 */

export function submit(ids) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/submit',
    method: 'get',
    params: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 详情
 * @param {number} id
 * @returns {any}
 */
export function info(id) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {{ids:string}} params
 * @description 删除
 */
export function remove(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/delete',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 审核驳回
 * @param {object} ids
 */

export function reject(data) {
  return service['api-web']({
    url: '/public/activiti/assemblyDisassemblyRelation/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 待办详情 (无需权限)
 * @param {{string}} id
 * @returns
 */
export function todoInfo(id) {
  return service['api-web']({
    url: '/public/activiti/assemblyAndDisassemblyRelation/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {number} id
 * @description 作废
 */
export function invalid(ids) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/invalid',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *
 * @description 下载
 */
export function downloadADRTemplate(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/downloadADRTemplate',
    method: 'post',
    data,
    responseType: 'blob',
    saveAs: false, // 文件流是否通过浏览器下载
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {{id:number | string,path:string}} data
 * @description 导入
 */
export function importAssemblyAndDisassemblyRelation(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/import',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 *
 * @description 导出
 */
export function exportData(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/export',
    method: 'post',
    data
    // responseType: 'blob', // 文件流接收类型声明转成 blob
    // saveAs: true // 文件流是否通过浏览器下载
  })
}

/**
 * 启用/禁用
 */
export function enableAndDisableDocument(data) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/enableAndDisableDocument',
    method: 'post',
    data
  })
}

// 反审核
export function rollback(id) {
  return service['api-web']({
    url: '/data/assemblyAndDisassemblyRelation/reverseAudit',
    method: 'post',
    data: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
